'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { errorsSelectors, errorsOperations } from '@/state/domains/errors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';
	
import { appSelectors, appOperations } from '@/state/domains/app';

import s from '../styles/common.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		loading: state.loading,
		modals: appSelectors.getModalStates(state, props),
	})
)(
	({ loading, modals }) => {

		const someOpen = Object.entries(modals).some(([ key, val ]) => val);

		return loading && (
			<div className={ sx('loading', { darken: !someOpen }) }>
				<div className={ s.inner }>
					<FontAwesomeIcon icon='circle-notch' size='5x' spin />
				</div>
			</div>
		);
	}
);
